import ClassSettings from '../editor/settings/ClassSettings';
import MenuSettings from '../editor/settings/MenuSettings';
import SettingCard from '../SettingCard';

const MenuBlockSettings = () => {
  return (
    <>
      <SettingCard title="Clase Css">
        <ClassSettings />
      </SettingCard>
      <SettingCard title="Menú">
        <MenuSettings />
      </SettingCard>
    </>
  );
};

export default MenuBlockSettings;
